export const NOT_THERE_YET_STRINGS = {
  title: 'We belong in',
  subtitle: `But we're not there yet.`,
  subtitle_x: 'But Belong PRO is not there yet.',
  cta: 'Done',
  'form.title': `We'll notify you when we open in`,
  'form.cta': `Notify me`,
  change_address: `CHANGE ADDRESS`,
  'phone.text': 'Questions? ',
  'thanks.text': 'Thanks so much for your interest',
  'no_zip_code.title': 'We need to verify a couple of',
  'no_zip_code.subtitle': 'points before we continue.',
  'no_zip_code.form_title': 'Someone at Belong will get back to shortly.',
  'belong_x.managing.yourself':
    'In the meantime, interested in help managing the home yourself?',
  'belong_x.guaranteed.rent':
    'Get guaranteed rent and more with BelongX today!',
  'cta.learn_more': 'Learn More',
  'no.thanks': 'NO, THANKS.',
};
